import { render } from "./GetClipboard.vue?vue&type=template&id=93116c90&ts=true"
import script from "./GetClipboard.vue?vue&type=script&lang=ts"
export * from "./GetClipboard.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/vivianerbenich/Desktop/git/greeting-card-automation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__